import { render, staticRenderFns } from "./bulkUpdate.vue?vue&type=template&id=c9ca6904&"
import script from "./bulkUpdate.vue?vue&type=script&lang=js&"
export * from "./bulkUpdate.vue?vue&type=script&lang=js&"
import style0 from "./bulkUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports